import { getUser } from "./Common";

/**
 * Tells the CMS socket server to refresh notification badges for staff (same as client follow-ups).
 */
export function emitStaffNotificationRefresh(socket, user) {
  const activeSocket =
    socket && typeof socket.emit === "function"
      ? socket
      : typeof window !== "undefined"
        ? window.__cmsStaffSocket
        : null;
  if (!activeSocket) return;
  const u = user ?? getUser();
  const senderName =
    typeof u === "string" || typeof u === "number"
      ? u
      : u?.name ?? u?.id ?? "";
  activeSocket.emit("sendNotification", { senderName });
}
